<template>        
    <FloatLabel class="w-[280px]">
        <AutoComplete 
            ref="autoCompleteRef" 
            class="w-full h-full autocomplete" 
            inputClass="!h-[40px] !text-sm"
            v-model="currentPerson" 
            :delay="600" 
            @item-select="personChange" 
            inputId="in_label" 
            dropdown 
            optionLabel="name" 
            :suggestions="physicalPersonsList" 
            @change="onSearchPhysicalPerson"  
            @focus="physicalPersonsPlaceholder = 'Поиск пользователей...'"
            @blur="onBlurPerson" 
            @click="onFocusInput"
            @dropdown-click="clearCurrentPerson"
            @complete="onCompleteSearch"
            :placeholder="physicalPersonsPlaceholder" 
            emptySearchMessage="Пользователь не найден" 
            :loading="isLoadingPhysicalPersonsList"                        
            size="small"            
            :appendTo="'body'"
        >                              
        <!-- <label for="in_label" class="!text-xs">Пользователи</label> -->
        <template #option="slotProps">
            <div class="w-full">
                <!-- <br v-if="topPerson && slotProps.index === 0">     -->
                <!-- Выделяем текущего пользователя -->
                <div :class="[prevCurrentPerson && slotProps.option.guid === prevCurrentPerson.guid ? 'font-bold' : '']">
                    {{ slotProps.option.name }}
                </div>

                <!-- Выделяем владельца кабинета если он задан -->
                <hr v-if="topPerson && slotProps.index === 0" class="my-1 border-gray-300" />
            </div>
        </template>
        </AutoComplete>  
    </FloatLabel>    
</template>      

<script>
import { UsersService } from "@/services/users.service";
import { PhysicalPersonsService } from "@/services/physical-persons"; 
import AutoComplete from 'primevue/autocomplete';
import FloatLabel from 'primevue/floatlabel';
import { isPermitionAllowed, isPermitionAllowedForRole } from '@/permissions';

export default {
  name: "SelectPersonDropdown",
  components: {
    AutoComplete,
    FloatLabel
  },
  props: {
    topPerson: {
      type: Object,    
      default: null,
    },
  },
  emits: ['update:modelValue', 'person-selected'],

  data() {
    return {
        currentPerson: null,
        prevCurrentPerson: null,
        currentUserGuid: null,
        physicalPersonsPlaceholder: '',
        isLoadingPhysicalPersonsList: false,
        allPhysicalPersonsList: [],
        physicalPersonsList: [],
    }
  },

  mounted() {
        this.setUpComponent();        
    },

  methods: {
    isPermitionAllowed, isPermitionAllowedForRole,

    setUpComponent() { 
        const userRole = this.$store.getters['user/getRoleCurentUser'];
        console.log("user/getRoleCurentUser", userRole);
        if (userRole !== '') {
            this.setOptions();           
        }
    }, 

    refresh() {
        this.setOptions();
    },

    setPerson(person) {
        this.currentPerson = person;
    },

    async setOptions() {
        this.isLoading = true;
        try {
            // const [{ data: physicalPersonResult }, { data: currentUserData }] = await Promise.all([
            //     PhysicalPersonsService.getPesonsList(),
            //     UsersService.getCurrent(),
            // ]);

            //const { data: currentUserData } = await UsersService.getCurrent();

            if (!this.$currentUser) {
                await $store.dispatch("user/getCurrent", { from: 'selectPersonDropdown' })
            }

            const currentUserData = this.$currentUser;

            if (this.isPermitionAllowedForRole('gettingPersonList', currentUserData.role)) {        
                const { data: physicalPersonResult } = await PhysicalPersonsService.getPesonsList();

                this.currentUserGuid = currentUserData.person_guid;
                
                let sortedList = physicalPersonResult?.sort((a, b) => a.name.localeCompare(b.name));

                // если передан topPerson – поднимаем его в начало
                if (this.topPerson) {
                    const index = sortedList.findIndex(p => p.guid === this.topPerson.guid);
                    if (index !== -1) {
                        const [person] = sortedList.splice(index, 1);
                        sortedList.unshift(person);
                    }
                }

                this.allPhysicalPersonsList = sortedList;

                const personGuid = this.$route.query.person_guid ?? currentUserData.person_guid;
                const selectedPerson = physicalPersonResult?.find(person => person.guid === personGuid);

                this.currentPerson = selectedPerson;
                this.prevCurrentPerson = selectedPerson;

                this.setState(selectedPerson);
            }

            // if (!this.$route.query.person_guid) {
            //     this.addFilterToPath();
            // }

            //this.showPersonSelect = true;
            //await this.loadBalance(this.currentPerson.guid);
        } catch (error) {
            console.error(error);
        } finally {
            this.isLoading = false;
        }
    },

    onBlurPerson() {
        this.restorePreviousPerson();
        this.physicalPersonsPlaceholder = "";
    },    

    async personChange(event) {
        this.isLoading = true
        
        this.prevCurrentPerson = event.value;         
        this.$refs.autoCompleteRef?.hide();
        
        //this.addFilterToPath();  
        //await this.loadBalance(this.currentPerson.guid);  
        this.setState(event.value);
        
        this.isLoading = false
    },

    setState(value) {
        this.$emit('person-selected', value);
    },

    restorePreviousPerson() {
        if (this.prevCurrentPerson && this.currentPerson && this.prevCurrentPerson.guid !==this.currentPerson.guid) {
            this.currentPerson = this.prevCurrentPerson 
        }
        if (!this.currentPerson && this.prevCurrentPerson) {
            this.currentPerson = this.prevCurrentPerson 
        }

        this.$refs.autoCompleteRef?.hide();
    },

    async onSearchPhysicalPerson(event) { 
        if (event?.value?.length >= 3) {
            this.isLoadingPhysicalPersonsList = true
            try {            
                const { data: physicalPersonResult } =  await PhysicalPersonsService.getPesonsList(event.value);
                this.physicalPersonsList = [...physicalPersonResult.sort((a, b) => a.name.localeCompare(b.name))];
            } catch (e) {                
                this.error = e.message
                console.log(e)                
                return
            } finally {
                this.isLoadingPhysicalPersonsList = false
            }
        } else {
            this.physicalPersonsList = this.allPhysicalPersonsList;
            this.isLoadingPhysicalPersonsList = false
        }
    },

    onFocusInput() {
        this.currentPerson = null;
        this.physicalPersonsList = [...this.allPhysicalPersonsList];
        this.$refs.autoCompleteRef?.show();
    },
    
    clearCurrentPerson() {
        this.currentPerson = null
        this.physicalPersonsList = [...this.allPhysicalPersonsList];
        this.$refs.autoCompleteRef?.show();
    },

    onCompleteSearch() {
        this.physicalPersonsList = [...this.physicalPersonsList]
    },

  },
};
</script>

<style scope>
.autocomplete {
  z-index: 2000 !important; 
}
</style>